<template>
  <div>
    <!-- FORGOT PASSWORD MODAL -->
    <b-modal id="forgotPassword" title="Reset password" class="imp-popup" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <p>
                  Please enter your email address to send the
                  <br />verification code on your mail.
                </p>
              </div>
              <div class="col-12">
                <input type="number" placeholder="Enter Phone number" class="form-control" />
              </div>
              <div class="col-12 my-2">
                <div class="small text-danger font-weight-light">Invalid Email address or password</div>
              </div>
              <div class="col-12">
                <button class="btn btn-primary w-100">PROCEED</button>
              </div>
            </div>
            <div class="col-12 text-center my-3">
              <span class="text-muted">Not a user?</span>
              <router-link to class="text-rose-gold" v-b-modal.signUp>Register with us!</router-link>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </div>
    </b-modal>

    <!-- RESET PASSWORD -->
    <b-modal id="forgotPassword" title="Reset password" class="imp-popup" hide-footer>
      <div>
        <div class="p-3">
          <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
            <div class="row my-4">
              <div class="col-12 text-center">
                <p>Please enter your new password</p>
              </div>
              <div class="col-12 mb-3 position-relative">
                <span class="passwordEyeIcon">
                  <img src="@/assets/img/icons/passwordEyeIcon.svg" alt />
                </span>
                <input type="password" placeholder="Enter new password" class="form-control pr-5" />
              </div>
              <div class="col-12 position-relative">
                <span class="passwordEyeIcon">
                  <img src="@/assets/img/icons/passwordEyeIcon.svg" alt />
                </span>

                <input type="number" placeholder="Confirm new password" class="form-control pr-5" />
              </div>
              <div class="col-12 my-2">
                <div class="small text-danger font-weight-light">Invalid Email address or password</div>
              </div>
              <div class="col-12">
                <small class="text-muted">Password should have a minimum of 6 characters.</small>
                <button class="btn btn-primary w-100">PROCEED</button>
              </div>
            </div>
            <div class="col-12 text-center my-3">
              <span class="text-muted">Not a user?</span>
              <router-link to class="text-rose-gold" v-b-modal.signUp>Register with us!</router-link>
            </div>
          </div>
        </div>
        <div class="rainbow-line">
          <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style>
.passwordEyeIcon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/modals/forgotPassword.vue